/**
 * Department-report sections arrive office → district-origin → children.
 * Reverse so the churches/districts rollup is the first tab, matching the
 * table users actually start with. A single section is left unchanged.
 */
export function orderReportSectionViews<T>(views: T[]): T[] {
  if (views.length <= 1) return views;
  return [...views].reverse();
}
